import React from "react";
import PropTypes from 'prop-types';
import styled from 'styled-components';

var Title = function Title(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    viewBox: "0 0 274 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "274",
    height: "32"
  }));
};

var Author = function Author(_ref2) {
  var className = _ref2.className;
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    viewBox: "0 0 171 36",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "171",
    height: "36"
  }));
};

var Medium = function Medium(_ref3) {
  var className = _ref3.className;
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    viewBox: "0 0 83 28",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "83",
    height: "28"
  }));
};

Title.propTypes = {
  className: PropTypes.string
};
Author.propTypes = {
  className: PropTypes.string
};
Medium.propTypes = {
  className: PropTypes.string
};
var TitlePlaceholder = styled(Title).withConfig({
  displayName: "text-loading-placeholder__TitlePlaceholder",
  componentId: "sc-jtq6sv-0"
})(["width:", ";height:", ";"], function (props) {
  return props.width;
}, function (props) {
  return props.height;
});
var AuthorPlaceholder = styled(Author).withConfig({
  displayName: "text-loading-placeholder__AuthorPlaceholder",
  componentId: "sc-jtq6sv-1"
})(["width:", ";height:", ";"], function (props) {
  return props.width;
}, function (props) {
  return props.height;
});
var MediumPlaceholder = styled(Medium).withConfig({
  displayName: "text-loading-placeholder__MediumPlaceholder",
  componentId: "sc-jtq6sv-2"
})(["width:", ";height:", ";"], function (props) {
  return props.width;
}, function (props) {
  return props.height;
});
export default {
  TitlePlaceholder: TitlePlaceholder,
  AuthorPlaceholder: AuthorPlaceholder,
  MediumPlaceholder: MediumPlaceholder
};